// extracted by mini-css-extract-plugin
export default {"result":"Exercise_result__j46R4","container":"Exercise_container__amanI","results":"Exercise_results__L8vfR"};